import { generateOneLinkUrl } from '@cian/appsflyer-onelink';
import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';

import { BANNER_TITLE } from './constants';
import { selectIsSmartBannerExperimentEnabled } from '../../selectors/experiments/selectIsSmartBannerExperimentEnabled';
import { useApplicationContext } from '../../utils/applicationContext';

export const HelmetContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const isSmartBannerExperimentEnabled = useSelector(selectIsSmartBannerExperimentEnabled);

  const [url, setUrl] = React.useState<string | null>(config.get<string>('mobileBanner.browserUrl') || null);

  React.useEffect(() => {
    setUrl(generateOneLinkUrl(url, 'mobile_site', BANNER_TITLE));
  }, []);

  if (!isSmartBannerExperimentEnabled || !url) {
    return;
  }

  return (
    <Helmet>
      <meta name="apple-itunes-app" content={`app-id=911804296, app-argument=${url}`} />
    </Helmet>
  );
};
